var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIconBarNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70711 6.2929C7.31659 5.90237 6.68342 5.90237 6.2929 6.29289C5.90237 6.68341 5.90237 7.31658 6.29289 7.7071L13.5916 15.0059L6.30021 22.2974C5.90969 22.6879 5.90969 23.3211 6.30022 23.7116C6.69074 24.1022 7.32391 24.1022 7.71443 23.7116L15.0058 16.4201L22.3183 23.7327C22.7088 24.1232 23.342 24.1232 23.7325 23.7327C24.123 23.3422 24.123 22.709 23.7325 22.3185L16.4201 15.0059L23.7131 7.71281C24.1036 7.32228 24.1036 6.68911 23.7131 6.29859C23.3226 5.90807 22.6894 5.90807 22.2989 6.2986L15.0058 13.5917L7.70711 6.2929Z",
    fill: "#F70F21",
    stroke: "#F70F21",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconBarNew);
export default __webpack_public_path__ + "static/media/cross-icon-bar-new.fb69e2ad3985da9cb85b68f92b3dd6ef.svg";
export { ForwardRef as ReactComponent };